export const PRIVACY_POLICY_HTML = `
  <div class="legal-document">
    <p class="legal-updated">Last Updated: August 2026</p>

    <p>Welcome to Magic Idle (the "Game"). By accessing or playing the Game, you agree to this Privacy Policy and Terms of Service. If you do not agree, please do not use the Game.</p>

    <hr class="legal-divider" />

    <h3>1. Privacy Policy</h3>
    <p>We respect your privacy and aim to collect only the minimum data required to run a real-time multiplayer game experience.</p>

    <h4>A. Information We Collect & Process</h4>
    <ul>
      <li>Transient Technical Data: When you connect to our servers, our infrastructure (e.g., CloudFront, Nginx, Node.js) automatically processes your IP address, browser type, and temporary WebSocket session IDs. This data is required strictly to establish and maintain real-time networking connections.</li>
      <li>Game State & Movement Data: Real-time gameplay coordinates (such as map positions) and session activity are processed in server memory while you are connected. This data is transient and is erased from server memory when you disconnect.</li>
      <li>Local Storage: The Game may store non-sensitive game progress, settings, or session tokens locally in your browser (<code>localStorage</code> or <code>IndexedDB</code>).</li>
    </ul>

    <h4>B. How We Use Your Data</h4>
    <p>We process data solely to:</p>
    <ul>
      <li>Operate, maintain, and render real-time multiplayer gameplay.</li>
      <li>Prevent server abuse, cheating, and malicious attacks.</li>
      <li>Save your local game progress.</li>
    </ul>
    <p>We do not sell, rent, or trade your personal data or IP address to third parties.</p>

    <h4>C. Data Security & Retention</h4>
    <ul>
      <li>All traffic is transmitted securely over encrypted protocols (<code>HTTPS</code> / <code>WSS</code>).</li>
      <li>Real-time networking data is kept in-memory only for the duration of your active game session.</li>
    </ul>

    <h4>D. Age Limitation</h4>
    <p>The Game is intended for users who are 13 years of age or older. We do not knowingly collect personal information from children under 13.</p>

    <hr class="legal-divider" />

    <h3>2. Terms of Service</h3>

    <h4>A. Acceptable Use & Rules of Conduct</h4>
    <p>To keep the Game fair and fun for everyone, you agree NOT to:</p>
    <ol>
      <li>Use automated bots, cheats, memory editors, or exploits to gain an unfair advantage.</li>
      <li>Intercept, reverse-engineer, or send forged WebSocket packets to our servers.</li>
      <li>Use the real-time chat or player names to send spam, offensive, harassing, illegal, or abusive content.</li>
      <li>Attempt to disrupt, overload, or execute denial-of-service (DoS) attacks against our backend infrastructure.</li>
    </ol>

    <h4>B. Account & Access Termination</h4>
    <p>We reserve the right to block, ban, or restrict access (via IP address or session tokens) to any user who violates these Terms of Service or harms the gameplay experience for others, at our sole discretion, without prior notice.</p>

    <h4>C. Game Availability & "As-Is" Service</h4>
    <ul>
      <li>The Game is provided on an "AS IS" and "AS AVAILABLE" basis.</li>
      <li>We make no guarantees that the Game will be uninterrupted, error-free, or that your local game progress will never be reset or lost due to server updates or maintenance.</li>
      <li>We reserve the right to modify, update, or discontinue any feature of the Game at any time without liability.</li>
    </ul>

    <h4>D. Limitation of Liability</h4>
    <p>To the maximum extent permitted by applicable law, the game creator/operator shall not be liable for any indirect, incidental, or consequential damages resulting from your use or inability to use the Game.</p>

    <hr class="legal-divider" />

    <h3>3. Contact Us</h3>
    <p>If you have questions about this policy or need to report an issue, please contact us at:</p>
    <p>Contact / Support: <a href="mailto:ArikarinoGames@gmail.com" class="legal-link">ArikarinoGames@gmail.com</a></p>
  </div>
`;